import styled from 'styled-components';

/* Bloco do veredito do Score (classe, faixa e pontuação) — vieram da antiga
   página avulsa de Score (`pages/Score/styles.ts`), removida quando o Score
   passou a vir na esteira. Sem mudança de visual: só a padding lateral cede,
   porque aqui o bloco já está dentro do accordion do serviço. */

export const VerdictBody = styled.div`
  display: flex;
  align-items: center;
  gap: 1.75rem;
  padding: 1rem 0 1.375rem;

  @media (max-width: 720px) {
    flex-wrap: wrap;
    gap: 1rem;
    padding: 0.75rem 0 1.25rem;
  }
`;

export const ClassBlock = styled.span<{ color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  flex: 0 0 auto;
  width: 104px;
  height: 104px;
  border-radius: var(--radius-lg);
  background: ${({ color }) => color};
  color: #fff;

  small {
    font-family: var(--font-mono);
    font-size: 0.62rem;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    opacity: 0.88;
  }

  strong {
    font-size: 3.5rem;
    font-weight: 700;
    line-height: 1;
  }

  @media (max-width: 720px) {
    width: 74px;
    height: 74px;

    strong {
      font-size: 2.5rem;
    }
  }
`;

export const VerdictText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  min-width: 0;

  h3 {
    margin: 0;
    font-size: 1.88rem;
    font-weight: 700;
    letter-spacing: -0.015em;
    color: var(--foreground);
  }

  p {
    margin: 0;
    font-size: 0.94rem;
    line-height: 1.5;
    color: var(--stone-700);
    max-width: 44ch;
  }

  @media (max-width: 720px) {
    h3 {
      font-size: 1.35rem;
    }
  }
`;

export const PointsBox = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex: 0 0 auto;

  @media (max-width: 720px) {
    margin-left: 0;
    align-items: flex-start;
  }
`;

export const PointsValue = styled.span`
  display: flex;
  align-items: baseline;
  gap: 4px;

  b {
    font-family: var(--font-mono);
    font-size: 4.5rem;
    font-weight: 700;
    line-height: 0.9;
    letter-spacing: -0.03em;
    color: var(--foreground);
  }

  span {
    font-family: var(--font-mono);
    font-size: 1.125rem;
    color: var(--muted-foreground);
  }

  @media (max-width: 720px) {
    b {
      font-size: 2.75rem;
    }
  }
`;

export const PointsLabel = styled.span`
  font-family: var(--font-mono);
  font-size: 0.62rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--stone-600);
  font-weight: 500;
`;

export const BandArea = styled.div`
  padding: 0 0 1rem;
`;

/* Nota curta abaixo de um bloco (ex.: aviso de que o score é informativo). */
export const DetailNote = styled.p`
  margin: 0.75rem 0 0;
  font-size: 0.75rem;
  line-height: 1.5;
  color: var(--stone-600);
`;
